/** Shared loading placeholder for lazy-loaded public VS viewers. */
export function ViewerSkeleton({
  height,
  label,
}: {
  height: number | string;
  label: string;
}) {
  return (
    <div
      className="flex w-full items-center justify-center rounded-lg bg-muted/40"
      style={{ height }}
    >
      <p className="text-xs text-muted-foreground">{label}</p>
    </div>
  );
}
